import api from 'api';

export default function sendNodeCommand(
  nodeAgentId: string,
  commandType: string,
  params: Record<string, unknown>,
) {
  return api
    .post(`node-agents/${nodeAgentId}/commands`, {
      json: {
        command_type: commandType,
        params,
      },
    })
    .then(() => {
      // Command sent successfully
    });
}
